import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";

function UnrotectedRoutes() {
  return (
    <>
      <NavBar />
      <Outlet />
    </>
  );
}

export default UnrotectedRoutes;
